import { endpoints } from '../api/sharedEndpoints';
import type { GroupCreateRequest, GroupDto, GroupsListResponse, GroupUpdateRequest } from '../api/types';

export interface GroupsRepository {
  listGroups(): Promise<GroupsListResponse>;
  createGroup(params: { payload: GroupCreateRequest }): Promise<GroupDto>;
  updateGroup(params: { groupId: string; payload: GroupUpdateRequest }): Promise<GroupDto>;
  deleteGroup(params: { groupId: string }): Promise<void>;
  inviteToGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto>;
  removeFromGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto>;
  confirmGroup(params: { groupId: string }): Promise<GroupDto>;
  leaveGroup(params: { groupId: string }): Promise<GroupDto>;
  joinGroup(params: { groupId: string }): Promise<GroupDto>;
}

export class ApiGroupsRepository implements GroupsRepository {
  async listGroups(): Promise<GroupsListResponse> {
    return endpoints.listGroups();
  }

  async createGroup(params: { payload: GroupCreateRequest }): Promise<GroupDto> {
    return endpoints.createGroup(params.payload);
  }

  async updateGroup(params: { groupId: string; payload: GroupUpdateRequest }): Promise<GroupDto> {
    return endpoints.updateGroup(params.groupId, params.payload);
  }

  async deleteGroup(params: { groupId: string }): Promise<void> {
    await endpoints.deleteGroup(params.groupId);
  }

  async inviteToGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto> {
    return endpoints.inviteToGroup(params.groupId, params.telegramIds);
  }

  async removeFromGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto> {
    return endpoints.removeFromGroup(params.groupId, params.telegramIds);
  }

  async confirmGroup(params: { groupId: string }): Promise<GroupDto> {
    return endpoints.confirmGroup(params.groupId);
  }

  async leaveGroup(params: { groupId: string }): Promise<GroupDto> {
    return endpoints.leaveGroup(params.groupId);
  }

  async joinGroup(params: { groupId: string }): Promise<GroupDto> {
    return endpoints.joinGroup(params.groupId);
  }
}
